import React, { Component } from "react";
import {
  Typography,
  Grid,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Chip,
} from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button, FormControl, Card } from "react-bootstrap";
import { PostData, GetData, DeleteData, PutData } from "../../api/service";
import Snack from "../Snackbar/Snack";
import FileUpload from "../AddNew/FileUpload";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import history from "../../history";

class FacultySeminar extends Component {
  state = {
    m_type: this.props.m_type,
    employee_id: this.props.employee_id,
    email: this.props.email,
    message: "",
    open: false,
    isLoaded: false,
    date_year: "",
    organised_by: "",
    theme: "",
    title: "",
    sponsored_by: "",
    seminar: [],
  };

  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  handleChangeInput = (name, value, index, array) => {
    let d = this.state[array];
    d[index][name] = value;
    this.setState({
      [array]: d,
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidMount() {
    //console.log(this.props);

    GetData(`/admin/${this.props.employee_id}/getsingleempolyeedataapi`).then(
      (resp) => {
        if (resp) {
          this.setState({
            ...resp,
          });
        }

        this.setState({
          isLoaded: true,
        });
      }
    );
  }

  onSubmit = (e) => {
    e.preventDefault();

    let d = this.state;

    PostData(`/admin/${this.props.employee_id}/addemployeeapi`, d).then(
      (resp) => {
        //console.log(resp)
        this.setState({
          message: resp,
          open: true,
        });
      }
    );
  };

  onAddClick = () => {
    let d = {
      date_year: this.state.date_year,
      organised_by: this.state.organised_by,
      theme: this.state.theme,
      title: this.state.title,
      sponsored_by: this.state.sponsored_by,
    };

    let seminar = this.state.seminar != null ? this.state.seminar : [];
    seminar.push(d);
    this.setState(
      {
        seminar,
      },
      () => {
        this.setState({
          date_year: "",
          organised_by: "",
          theme: "",
          title: "",
          sponsored_by: "",
        });
      }
    );
  };

  onDelete = (index) => {
    let seminar = this.state.seminar;
    seminar.splice(index, 1);

    this.setState({
      seminar,
    });
  };

  render() {
    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            message={this.state.message}
            handleClose={() => {
              this.setState({
                open: false,
                message: "",
              });
            }}
          />
        ) : null}

        {this.state.isLoaded && (
          <form onSubmit={this.onSubmit}>
            <Typography variant="h6" gutterBottom>
              {this.props.title}
            </Typography>

            <table width="100%" className="table">
              <thead>
                <tr>
                  <td>Organized by</td>
                  <td>Title of the Seminar/Workshop/Conference</td>
                  <td>Title of the Paper Presented</td>

                  <td>Sponsored by</td>
                  <td>Date & Year</td>

                  <td>Click + to Add</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="organised_by"
                      value={this.state.organised_by}
                      onChange={this.onChange}
                      placeholder="Organized by"
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="theme"
                      value={this.state.theme}
                      onChange={this.onChange}
                      placeholder="Title"
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="title"
                      value={this.state.title}
                      onChange={this.onChange}
                      placeholder="Title"
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="sponsored_by"
                      value={this.state.sponsored_by}
                      onChange={this.onChange}
                      placeholder="Seminar
                  sponsored by"
                    />
                  </td>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      name="date_year"
                      value={this.state.date_year}
                      onChange={this.onChange}
                      placeholder="Date & Year"
                    />
                  </td>

                  <td>
                    <Button
                      variant="outlined"
                      onClick={this.onAddClick}
                      type="button"
                    >
                      +
                    </Button>
                  </td>
                </tr>
              </tbody>
              <tbody>
                {Array.isArray(this.state.seminar) &&
                  this.state.seminar.map((el, index) => (
                    <tr key={index}>
                      <td>
                        <textarea
                          className="form-control"
                          type="text"
                          name="organised_by"
                          rows={5}
                          value={el.organised_by}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "organised_by",
                              e.target.value,
                              index,
                              "seminar"
                            )
                          }
                          placeholder="Organized by"
                        />
                      </td>
                      <td>
                        <textarea
                          className="form-control"
                          type="text"
                          name="theme"
                          rows={5}
                          value={el.theme}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "theme",
                              e.target.value,
                              index,
                              "seminar"
                            )
                          }
                          placeholder="Theme"
                        />
                      </td>

                      <td>
                        <textarea
                          className="form-control"
                          type="text"
                          name="title"
                          rows={5}
                          value={el.title}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "title",
                              e.target.value,
                              index,
                              "seminar"
                            )
                          }
                          placeholder="Title of the Paper Presented	"
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          type="text"
                          name="sponsored_by"
                          rows={5}
                          value={el.sponsored_by}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "sponsored_by",
                              e.target.value,
                              index,
                              "seminar"
                            )
                          }
                          placeholder="Sponsored by	"
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          type="text"
                          name="date_year"
                          rows={5}
                          value={el.date_year}
                          onChange={(e) =>
                            this.handleChangeInput(
                              "date_year",
                              e.target.value,
                              index,
                              "seminar"
                            )
                          }
                          placeholder="Year"
                        />
                      </td>

                      <td>
                        <Delete onClick={this.onDelete.bind(this, index)} />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <br />
            <div align="right">
              <Button size="sm" variant="info" type="submit">
                Submit
              </Button>
            </div>
          </form>
        )}
      </div>
    );
  }
}

export default FacultySeminar;
